import request from "root/js/request";

//
export const getParsersCompanyFinances = async ({ seller_id, ...rest }) => {
  const response = await request({
    url: "/parsers/company_finances/",
    method: "get",
    params: {
      seller_id,
      ...rest,
    },
  });

  return response.data;
};
